import { useIntl } from "react-intl"
import { useRef, useState, useEffect, useMemo } from "react"
import { Combobox, CustomTable, InputDate, Modal } from "medere-ui-framework"
import { getReportStretcherBearer, getStretcherBearerInformation, getSectors, getStretcherBearers, getPercentagesOfConveyances, getPercentagesOfStatus, getPercentagesOfCancellationReasons, getPatientTransferPendingProgressList, sendTokenToServer, getPatients, getLoguedStretcherBearers, getAverageEstimatedDelay } from "../servicesHooks/Transfer/useTransferService"
import { Column } from "primereact/column"
import { Button } from "primereact/button";
import { format, parseISO } from 'date-fns';
import { TimeField } from '@mui/x-date-pickers/TimeField';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TransferStatus } from "./StretcherBearerView";
import { TransferRequestCard } from "../components/InfoCard/TransferRequestCard";
import LinedCard from "../components/InfoCard/LinedCard";
import { TabView, TabPanel } from 'primereact/tabview';
import { getToken } from "firebase/messaging";
import { messaging, onMessageListener } from "../App";
import { onMessage } from "firebase/messaging";
import { Toast, ToastMessage } from 'primereact/toast';
import { Icon } from '@iconify/react';
import HeatMapPatientTransferView from "./Heatmap/HeatMapPatientTransferView";
import MobileTabSelector, { MobileTabSelectorOption } from "./Location/components/MobileTabSelector";
import "./TransfersStatisticsView.scss";

export default function TransfersStatisticsView() {

    /* const vapidKey: string | null = searchParams.get('vapidKey'); */
    const [vapidKey, setVapidKey] = useState<string | undefined>();
    const [userId, setUserId] = useState<number>(0);
    useEffect(() => {
        //TODO maxi: traer los datos de la API
        setVapidKey('');
        setUserId(-1);
    }, []);

    const intl = useIntl();
    const queryRef:any = useRef(null)
    const queryRefPending:any = useRef(null)
    const toast = useRef(null);
    const [fromDate, setFromDate] = useState<Date | null>(generateFromDate())
    const [toDate, setToDate] = useState<Date | null>(generateToDate())
    const [selectedSector, setSelectedSector] = useState<any>(null)
    const [selectedStretcherBearer, setSelectedStretcherBearer] = useState<any>(null)
    const [selectedPatient, setSelectedPatient] = useState<any>(null)
    const [stretcherBearerData, setStretcherBearerData] = useState<StretcherBearerPerOfTransfers[]>();
    const [loguedStretcherBearersData, setLoguedStretcherBearersData] = useState<LoguedStretcherBearerDTO[]>();
    const [conveyanceData, setConveyanceData] = useState<any[]>();
    const [statusData, setStatusData] = useState<any[]>();
    const [cancellationReasonData, setCancellationReasonData] = useState<any[]>();
    const todayDate = new Date()
    const maxDate = new Date(todayDate);
    maxDate.setDate(maxDate.getDate() + 1);
    const [fromTime, setFromTime] = useState(dayjs('2022-04-17T00:00'));
    const [toTime, setToTime] = useState(dayjs('2022-04-17T23:59'));
    const [fromHour, setFromHour] = useState("0");
    const [fromMinute, setFromMinute] = useState("0");
    const [toHour, setToHour] = useState("23");
    const [toMinute, setToMinute] = useState("59");
    const [openDetailsWindow, setOpenDetailsWindow] = useState(false)
    const [openCommentWindow, setOpenCommentWindow] = useState(false)
    const [comments, setComments] = useState<string>();
    const [cancellationReasonDescription, setCancellationReasonDescription] = useState<string>();
    const [cancellationReasonDetail, setCancellationReasonDetail] = useState<string>();
    const [recordStatus, setRecordStatus] = useState<number>();
    const [selectedTransferRequest, setSelectedTransferRequest] = useState<PatientTransferDTO>();
    const [openPendingProgressWindow, setOpenPendingProgressWindow] = useState(false);
    const [isNotificationDisabled, setIsNotificationDisabled] = useState(false);
    const isAndroid = /Android/i.test(navigator.userAgent)
    const isIPhone = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const [averages, setAverages] = useState({
      avgRequestFrom: '00:00:00',
      avgFromDateFromPatientDate: '00:00:00',
      avgFromPatientTo: '00:00:00',
      avgRequestedTo: '00:00:00',
    });
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isWidthLessThan1084, setIsWidthLessThan1084] = useState(window.innerWidth < 1084);
    const [activeTab, setActiveTab] = useState(0);
    const [openReportDataWindow, setOpenReportDataWindow] = useState(false);
    const formattedFromDate = fromDate? fromDate.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' }):"";
    const formattedToDate = toDate? toDate.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' }):"";
    const [openLoguedStretcherBearersWindow, setOpenLoguedStretcherBearersWindow] = useState(false);
    const [averageEstimatedDelay, setAverageEstimatedDelay] = useState<number>();

    const tabOptions = useMemo<MobileTabSelectorOption[]>(() => ([
      { id: 0, label: intl.formatMessage({ id: 'Actives' }) },
      { id: 1, label: intl.formatMessage({ id: 'Finisheds' }) },
      { id: 2, label: 'Análisis Día/Hora' },
    ]), [intl]);

    const protocolo = window.location.protocol;
    const dominio = window.location.hostname;
    const urlBase = `${protocolo}//${dominio}`;

    onMessageListener()
    .then((payload) => {
        console.log('onMessage received. ', payload);
        queryRefPending.current.refreshTable();
        if (fromDate && toDate) {
          fetchReportData();
        }
    }).catch((err) => console.log('failed: ', err));

    onMessage(messaging, (payload) => {
      console.log("onMessage received, payload: ", payload)
      queryRefPending.current.refreshTable();
    });

    useEffect(() => {
      navigator.serviceWorker.register(`${urlBase}/firebase/firebase-messaging-sw.js`)//poner ${urlBase}:8080 para probar en dev
      .then((registration) => {
          console.log("se registro el service worker", registration)
          requestNotificationPermission(registration)
      })
      .catch((error) => {
          console.error('Service worker registration failed:', error);
      });
      /*navigator.serviceWorker.register(`/firebase-messaging-sw.js`)
      .then((registration) => {
          console.log("se registro el service worker", registration)
          requestNotificationPermission(registration)
      })
      .catch((error) => {
          console.error('Service worker registration failed:', error);
      });*/
    }, []);

    function requestNotificationPermission(registration: ServiceWorkerRegistration) {
      console.log('Requesting permission...');
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
            console.log('Notification permission granted.');
            getTokenAndSendToServer(registration);
        }else {
            console.log('El usuario denegó el permiso para notificaciones.');
            setIsNotificationDisabled(true)
        }
      })
    }
            
    function getTokenAndSendToServer(registration: ServiceWorkerRegistration) {
      getToken(messaging, {vapidKey: vapidKey, serviceWorkerRegistration: registration}).then((currentToken) => {
        if (currentToken) {
          sendTokenToServer(currentToken)
          .then((msgError: { statusCode: number }) => {
            if (msgError.statusCode == 208){
                showMessage("Error al guardar el token", toast, 'error')
            }else{
                console.log("Se guardo el token")
            }    
          })
          .catch((error: any) => {
            console.error('Error al guardar los datos:', error);
          }).finally(()=>{
            queryRefPending.current.refreshTable();
          })
        } else {
          console.log('No registration token available. Request permission to generate one.');
          showMessage("No registration token available. Request permission to generate one.", toast, 'error')
        }
      }).catch((err:any) => {
          console.log('An error occurred while retrieving token. ', err);
      });
    }

    const showMessage = (msg: any, ref: React.RefObject<Toast>, severity: ToastMessage['severity']) => {
      ref.current?.show({ severity: severity, summary: msg, life: 3000 });
    };

    const handleFromTimeChange = (newTime:any) => {
      setFromTime(newTime);
      setFromHour(newTime.hour());
      setFromMinute(newTime.minute());
    };

    const handleToTimeChange = (newTime:any) => {
      setToTime(newTime);
      setToHour(newTime.hour());
      setToMinute(newTime.minute());
    };

    type StretcherBearerPerOfTransfers = {userstretbearer: number, fullname: string, percentageoftransfers: string, transferquantitypersb: number, avgrequestfrom: string, avgfromdatefrompatientdate: string, avgfrompatientto: string, avgrequestedto: string}
    type PatientTransferDTO = { patienttransfer: number, relatedpatienttransfer: number, fullname: string, newsector:number, currentsector:number, conveyance: string, oxygen: boolean, medereentity: number, currentstatus: number, requestedtime: Date, transferfromdate: Date, transferdatefrompatient: Date, transfertodate: Date, frombed: number, tobed: number, comments: string, cancellationreason:number, cancellationreasondescription: string, cancellationreasondetail: string, clinichistoryid: string, _user: number}
    type LoguedStretcherBearerDTO = {profile: number, _user: number, auditeventtype: number, patienttransfer: number, stretbearerfullname: string}

    function generateFromDate() {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 1);

        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = 1;

        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;

        const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;

        return new Date(formattedDate);
    }

    function generateToDate() {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 1);

        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();

        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;

        const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;

        return new Date(formattedDate);
    }

    const fetchReportData = () => {

      const fromHourInt = fromHour!= null? Number(fromHour): null;
      const fromMinuteInt = fromMinute!= null? Number(fromMinute): null;
      const toHourInt = toHour!= null? Number(toHour): null;
      const toMinuteInt = toMinute!= null? Number(toMinute): null;

      getReportStretcherBearer(0, 0, fromDate, toDate, selectedSector?selectedSector.sector:null, selectedStretcherBearer?selectedStretcherBearer._userstretbearer:null, selectedPatient?selectedPatient.medereentity:null, Number(fromHourInt), Number(fromMinuteInt), Number(toHourInt), Number(toMinuteInt))
      .then((response) => {
        setStretcherBearerData(response)
      })
      .catch((error) => {
        console.error(error);
      });

      getPercentagesOfConveyances(0, 0, fromDate, toDate, selectedSector?selectedSector.sector:null, selectedStretcherBearer?selectedStretcherBearer._userstretbearer:null, selectedPatient?selectedPatient.medereentity:null, Number(fromHourInt), Number(fromMinuteInt), Number(toHourInt), Number(toMinuteInt))
      .then((response) => {

        setConveyanceData(response)

      })
      .catch((error) => {
        console.error(error);
      });

      getPercentagesOfStatus(0, 0, fromDate, toDate, selectedSector?selectedSector.sector:null, selectedStretcherBearer?selectedStretcherBearer._userstretbearer:null, selectedPatient?selectedPatient.medereentity:null, Number(fromHourInt), Number(fromMinuteInt), Number(toHourInt), Number(toMinuteInt))
      .then((response) => {

        setStatusData(response)

      })
      .catch((error) => {
        console.error(error);
      });

      getPercentagesOfCancellationReasons(0, 0,fromDate, toDate, selectedSector?selectedSector.sector:null, selectedStretcherBearer?selectedStretcherBearer._userstretbearer:null, selectedPatient?selectedPatient.medereentity:null, Number(fromHourInt), Number(fromMinuteInt), Number(toHourInt), Number(toMinuteInt))
      .then((response) => {

        setCancellationReasonData(response)

      })
      .catch((error) => {
        console.error(error);
      });

      getLoguedStretcherBearers()
      .then((response) => {

        setLoguedStretcherBearersData(response)

      })
      .catch((error) => {
        console.error(error);
      });

      getAverageEstimatedDelay()
      .then((response) => {

        setAverageEstimatedDelay(response)
        
      })
      .catch((error) => {
        console.error(error);
      });

    };
    
    useEffect(() => {
        fetchReportData();
    }, [fromDate, toDate, selectedSector, selectedStretcherBearer, selectedPatient, fromHour, fromMinute, toHour, toMinute]);

    const calculateAverages = (data:any) => {
      if (!data || data.length === 0) return { avgRequestFrom: '00:00:00', avgFromDateFromPatientDate: '00:00:00', avgFromPatientTo: '00:00:00', avgRequestedTo: '00:00:00' };
    
      let totalAvgRequestFromInSeconds = 0;
      let totalAvgFromDateFromPatientDate = 0;
      let totalAvgFromPatientToInSeconds = 0;
      let totalAvgRequestedToInSeconds = 0;
    
      data.forEach((item:any) => {
        const avgRequestFromParts = item.avgrequestfrom.split(':');
        const avgRequestedToParts = item.avgrequestedto.split(':');
    
        totalAvgRequestFromInSeconds +=
          parseInt(avgRequestFromParts[0]) * 3600 +
          parseInt(avgRequestFromParts[1]) * 60 +
          parseInt(avgRequestFromParts[2]);
    
        totalAvgRequestedToInSeconds +=
          parseInt(avgRequestedToParts[0]) * 3600 +
          parseInt(avgRequestedToParts[1]) * 60 +
          parseInt(avgRequestedToParts[2]);
    
        if (item.avgfromdatefrompatientdate && item.avgfromdatefrompatientdate.trim() !== '') {
          const avgFromDateFromPatientDateParts = item.avgfromdatefrompatientdate.split(':');
          totalAvgFromDateFromPatientDate +=
            parseInt(avgFromDateFromPatientDateParts[0]) * 3600 +
            parseInt(avgFromDateFromPatientDateParts[1]) * 60 +
            parseInt(avgFromDateFromPatientDateParts[2]);
        }
    
        if (item.avgfrompatientto && item.avgfrompatientto.trim() !== '') {
          const avgFromPatientToParts = item.avgfrompatientto.split(':');
          totalAvgFromPatientToInSeconds +=
            parseInt(avgFromPatientToParts[0]) * 3600 +
            parseInt(avgFromPatientToParts[1]) * 60 +
            parseInt(avgFromPatientToParts[2]);
        }
      });
    
      const avgRequestFromSeconds = Math.round(totalAvgRequestFromInSeconds / data.length);
      const avgFromDateFromPatientDateSeconds = Math.round(totalAvgFromDateFromPatientDate / data.length);
      const avgFromPatientToSeconds = Math.round(totalAvgFromPatientToInSeconds / data.length);
      const avgRequestedToSeconds = Math.round(totalAvgRequestedToInSeconds / data.length);
    
      const formatTime = (seconds:any) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secondsRemainder = seconds % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secondsRemainder.toString().padStart(2, '0')}`;
      };

      return {
        avgRequestFrom: formatTime(avgRequestFromSeconds),
        avgFromDateFromPatientDate: formatTime(avgFromDateFromPatientDateSeconds),
        avgFromPatientTo: formatTime(avgFromPatientToSeconds),
        avgRequestedTo: formatTime(avgRequestedToSeconds),
      };
    };

    useEffect(() => {
      if (stretcherBearerData)
        setAverages(calculateAverages(stretcherBearerData))
    }, [stretcherBearerData]);
    
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
        setIsWidthLessThan1084(window.innerWidth < 1084);
      };
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    function handleClickComments(record:PatientTransferDTO){
      const {currentstatus, comments, cancellationreasondescription, cancellationreasondetail} = record
      setRecordStatus(currentstatus)
      
      setComments(comments)
    
      setCancellationReasonDescription(cancellationreasondescription)
      setCancellationReasonDetail(cancellationreasondetail)
    
      setOpenCommentWindow(true)
    }

    function handleClickDetails(record:PatientTransferDTO){
      setSelectedTransferRequest(record)
      setOpenDetailsWindow(true)
    }

    function handleClickPendingProgress(record:PatientTransferDTO){
        setSelectedTransferRequest(record)
        setOpenPendingProgressWindow(true)
    }

    return (
        <div className="m-4 flex flex-column viewContainer transfers-statistics-view">
            <h2 style={{color: '#B67345', fontWeight: 600}} className="text-2xl">{intl.formatMessage({ id: 'Reports' })+ ' / ' +intl.formatMessage({ id: 'TransfersHistory' })}</h2>
            {isMobile ? (
              <MobileTabSelector
                id="transferstatisticstabselectorid"
                className="transfers-mobile-tab-selector"
                value={activeTab}
                options={tabOptions}
                onChange={(id) => setActiveTab(Number(id))}
                ariaLabel="Seleccionar tab de transferencias"
              />
            ) : null}
            <TabView
              panelContainerClassName="flex flex-column flex-grow"
              className="flex-grow flex flex-column transfers-mobile-tabview"
              activeIndex={activeTab}
              onTabChange={(e) => setActiveTab(e.index)}
            >
              <TabPanel className="flex flex-column flex-grow" header={intl.formatMessage({ id: 'Actives' })}>

                <div className="gap-2" style={{marginTop:'10px', display:'flex', flexDirection: isMobile ? "column" : "row"}}>

                  <div style={{marginBottom:'10px', display:'flex'}} className="smallCardContainer">
                    <button className="h-full w-full" style={{display:'flex', justifyContent:'space-between', background:'transparent', border:'none', width:'100%', textAlign: 'left', paddingLeft:'10px', paddingTop:'5px'}} onClick={() => setOpenLoguedStretcherBearersWindow(true)}>
                      <div style={{ marginLeft:'5px', paddingBottom:'15px' }}>
                        <span style={{color:'#999999'}}>{intl.formatMessage({id: 'StretcherBearers'})}</span>
                        <h3 style={{ fontSize: '16px', color: 'black', fontWeight: 600 }}>{loguedStretcherBearersData && loguedStretcherBearersData.length >= 0? loguedStretcherBearersData.length:0} {loguedStretcherBearersData?.length != 1? intl.formatMessage({ id: 'Logueds' }):intl.formatMessage({ id: 'Logued' })}</h3>
                      </div>
                      <div style={{marginRight:'10px', paddingTop:'2px'}}>
                        <Icon icon='bi:person-fill' style={{color:'#272727', backgroundColor: '#f9dad6', fontSize: '40px', borderRadius: '4px', padding: '10px'}}/>
                      </div>
                    </button>
                  </div>

                  <div style={{marginBottom:'10px', display:'flex', justifyContent: 'space-between', paddingTop:'5px'}} className="smallCardContainer">
                    <div style={{ marginLeft:'5px', paddingBottom:'25px' }}>
                      <span style={{color:'#999999'}}>{intl.formatMessage({id: 'EstimatedDelay'})}</span>
                      <h3 style={{ fontSize: '16px', color: 'black', fontWeight: 600 }}>{averageEstimatedDelay+' '+intl.formatMessage({id: 'hours'})}</h3>
                    </div>
                    <div style={{marginRight:'10px', paddingTop:'2px'}}>
                      <Icon icon='bi:clock' style={{color:'#272727', backgroundColor: '#f9dad6', fontSize: '40px', borderRadius: '4px', padding: '10px'}}/>
                    </div>
                  </div>

                </div>

                <CustomTable filterRow idTable="tablePendingProgress" getItems={getPatientTransferPendingProgressList} hideFiltersButton showGridlines params={{
                  sector:selectedSector?selectedSector.sector:null,
                  fromDate:fromDate,
                  toDate:toDate}} className="crudTable" ref={queryRefPending} itemSize={10}>

                  <Column
                    field="openDetail"
                    body={(record:PatientTransferDTO) => {
                      const buttonStyle = {
                        height: '23px',
                        color: '#14C7BC',
                        backgroundColor: 'transparent',
                        border: 'none',
                        marginLeft: '2px',
                      };
                      return (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                          onClick={() => handleClickPendingProgress(record)}
                          icon='pi pi-eye'
                          iconPos= "left"
                          style={buttonStyle}
                        />
                      </div>
                    );}} className="columnSquare columnGen"
                  />
                  <Column
                    field="openWindow"
                    header={intl.formatMessage({ id: 'Status' })}
                    body={(record) => {
                      const isInProgress = record.currentstatus === TransferStatus.INPROGRESS;
                      return (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span style={{ marginLeft: '1px' }}>
                            {isInProgress? <span style={{ color: 'green', fontWeight: 500 }}>{intl.formatMessage({ id: 'inProgress' })}</span>: <span style={{ color: 'black', fontWeight: 500 }}>{intl.formatMessage({ id: 'pending' })}</span>}
                          </span>
                        </div>
                      );
                  }} className="columnSt columnGen "/>
                  <Column field="prioritydescription" header={intl.formatMessage({id:'Priority'})} 
                    body={(record) => {
                      return (
                        <span style={{ color: '#393939', fontWeight: 500 }}>{record.prioritydescription}</span>
                      );
                  }} className="columnDly columnGen"/>
                  <Column field="fullname" header={intl.formatMessage({ id: 'CH' }) + ' - ' + intl.formatMessage({ id: 'Patient' })} className="column columnGen"
                    body={(record:PatientTransferDTO) => {
                      return (
                        <span style={{ marginLeft: '1px' }}>
                          {record.clinichistoryid} - {record.fullname}
                        </span>
                    );}}
                  />
                  <Column field="requestedtime" header={intl.formatMessage({id:'RequestedTime'})} className="columnDt columnGen" body={(x)=>{
                    return format(parseISO(x.requestedtime),'dd/MM/yyyy HH:mm')
                  }}/>
                  <Column field="namecurrentsector" header={intl.formatMessage({id:'Origin'})} className="column columnGen"/>
                  <Column field="namenewsector" header={intl.formatMessage({id:'Destiny'})} className="column columnGen"/>
                  <Column field="stretcherbearername" header={intl.formatMessage({ id: 'StretcherBearer' })} className="column columnGen" />
                </CustomTable>
              </TabPanel>
              <TabPanel className="flex flex-column flex-grow" header={intl.formatMessage({ id: 'Finisheds' })}>
                <div className="flex md:gap-4 gap-2 align-items-end flex-column md:flex-row">

                  <div className="flex gap-3 align-items-end flex-column md:flex-row w-full">
                    <div className="flex flex-row w-full gap-3">
                      <InputDate label={intl.formatMessage({ id: 'from' })} value={fromDate} onChange={(e: any) => setFromDate(e.value)} maxDate={todayDate} className="w-145 mt-2.5"/>
                      <InputDate label={intl.formatMessage({ id: 'to' })} value={toDate} onChange={(e: any) => setToDate(e.value)} maxDate={maxDate} className="w-145 mt-2.5"/>
                    </div>

                    <div className="flex justify-content-center space-x-5">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div style={{ marginLeft: isMobile? '75px':'' }}>
                          <span>{intl.formatMessage({ id: 'from' })}</span>
                          <TimeField
                            value={fromTime}
                            onChange={handleFromTimeChange}
                            format="HH:mm"
                            className="w-70 h-48"
                            size="small"
                          />
                        </div>
                        <div style={{ marginRight: isMobile? '75px':'' }}>
                          <span>{intl.formatMessage({ id: 'to' })}</span>
                          <TimeField
                            value={toTime}
                            onChange={handleToTimeChange}
                            format="HH:mm"
                            className="w-70 h-48"
                            size="small"
                          />
                        </div>
                      </LocalizationProvider>
                    </div>
                    
                    <Combobox label={intl.formatMessage({id:'StretcherBearer'})} getItems={getStretcherBearers} optionLabel='stretbearerfullname' setValue={setSelectedStretcherBearer} value={selectedStretcherBearer} className="w-41"/>
                    <Combobox label={intl.formatMessage({id:'Patient'})} getItems={getPatients} optionLabel='fullname' setValue={setSelectedPatient} value={selectedPatient} className="w-41"/>
                    <Combobox label={intl.formatMessage({id:'sector'})} getItems={getSectors}optionLabel='name' setValue={setSelectedSector} value={selectedSector} className="w-41"/>                    
                  </div>

                </div>

                <div className="gap-2" style={{marginTop:'10px', display:'flex', flexDirection: isMobile ? "column" : "row"}}>

                  <div style={{marginBottom:'10px', display:'flex'}} className="smallCardContainer">
                    <button className="h-full w-full" style={{display:'flex', justifyContent:'space-between', background:'transparent', border:'none', width:'100%', textAlign: 'left', paddingLeft:'10px', paddingTop:'5px'}} onClick={() => setOpenReportDataWindow(true)}>
                      <div style={{ marginLeft:'5px', paddingBottom:'15px' }}>
                        <span style={{color:'#999999'}}>{intl.formatMessage({id: 'Transfers'})}</span>
                        <h3 style={{ fontSize: '16px', color: 'black', fontWeight: 600 }}>{stretcherBearerData && stretcherBearerData.length > 0 && (stretcherBearerData.reduce((total, item) => total + item.transferquantitypersb, 0))} {intl.formatMessage({ id: 'Requesteds' })}</h3>
                        <br/>
                        <span style={{marginTop:'20px'}}>
                          {statusData && statusData.length > 0 && (
                            statusData.map((item, index) => (
                              <div key={index}>
                                <span style={{fontSize: '16px', display:'flex' }}><span style={{marginRight:'5px', fontWeight:500, color: item.description==intl.formatMessage({ id: 'Finished' })?'#18C43A':''}}>{item.description==intl.formatMessage({ id: 'Finished' })?item.percentageofstatus:''}</span> {item.description==intl.formatMessage({ id: 'Finished' })? <span style={{color:'#AAAAAA'}}>{item.description}</span>:''}{item.description=="Finalizado"? <span style={{color:'#AAAAAA'}}>s</span>:''}</span>
                              </div>
                            ))
                          )}
                        </span>
                      </div>
                      <div style={{marginRight:'10px', paddingTop:'2px'}}>
                        <Icon icon='bi:arrow-left-right' style={{color:'#272727', backgroundColor: '#f9dad6', fontSize: '40px', borderRadius: '4px', padding: '10px'}}/>
                      </div>
                    </button>
                  </div>

                  <div style={{marginBottom:'10px', display:'flex'}} className="smallCardContainer">
                    <button className="h-full w-full" style={{display:'flex', justifyContent:'space-between', background:'transparent', border:'none', width:'100%', textAlign: 'left', paddingBottom:'5px', paddingLeft:'10px', paddingTop:'10px', paddingRight:'10px'}} onClick={() => setOpenReportDataWindow(true)}>
                      <div style={{ marginLeft:'5px', paddingBottom:'30px' }}>
                        <span style={{color:'#999999'}}>{intl.formatMessage({id: 'Statuss'})}</span>
                        {statusData && statusData.length > 0 && (
                          statusData.map((item, index) => (
                            <div key={index}>
                              <h3 style={{fontSize: isWidthLessThan1084 && !isMobile? '14px':'16px', color: 'black', fontWeight: 600, display:'flex' }}>{item.percentageofstatus} {item.description}{item.description=="Finalizado" || item.description=="Cancelado"? 's':''}</h3>
                            </div>
                          ))
                        )}
                      </div>  
                      <div>
                        <Icon icon='bi:check' style={{color:'#272727', backgroundColor: '#f9dad6', fontSize: '40px', borderRadius: '4px', padding: '10px'}}/>
                      </div>
                    </button>
                  </div>

                  <div style={{marginBottom:'10px', display:'flex'}} className="smallCardContainer">
                    <button className="h-full w-full" style={{display:'flex', justifyContent:'space-between', background:'transparent', border:'none', width:'100%', textAlign: 'left', paddingLeft:'10px', paddingTop:'8px', paddingBottom:'30px'}} onClick={() => setOpenReportDataWindow(true)}>
                      <div style={{ marginLeft:'5px', paddingBottom:'25px' }}>
                        <span style={{color:'#999999'}}>{intl.formatMessage({id: 'AverageDuration'})}</span>
                        <h3 style={{ fontSize: '16px', color: 'black', fontWeight: 600 }}>{averages.avgRequestedTo+' '+intl.formatMessage({id: 'hours'})}</h3>
                      </div>
                      <div style={{marginRight:'10px'}}>
                        <Icon icon='bi:clock' style={{color:'#272727', backgroundColor: '#f9dad6', fontSize: '40px', borderRadius: '4px', padding: '10px'}}/>
                      </div>
                    </button>
                  </div>

                  <div style={{marginBottom:'10px', display:'flex'}} className="smallCardContainer">
                    <button className="h-full w-full" style={{display:'flex', justifyContent:'space-between', background:'transparent', border:'none', width:'100%', textAlign: 'left', paddingBottom:'7px', paddingLeft:'10px', paddingTop:'8px'}} onClick={() => setOpenReportDataWindow(true)}>
                      <div style={{ marginLeft:'5px', paddingBottom:'20px' }}>
                        <span style={{color:'#999999'}}>{intl.formatMessage({id: 'conveyance'})}</span>
                        {conveyanceData && conveyanceData.length > 0 && (
                          conveyanceData.map((item, index) => (
                            <div key={index}>
                              <h3 style={{ fontSize: isWidthLessThan1084 && !isMobile? '14px':'16px', color: 'black', fontWeight: 600 }}>{item.percentageofconveyances} {item.conveyance}</h3>
                            </div>
                          ))
                        )}
                      </div>
                      <div style={{marginRight:'10px'}}>
                        <Icon icon='bi:person-wheelchair' style={{color:'#272727', backgroundColor: '#f9dad6', fontSize: '40px', borderRadius: '4px', padding: '10px'}}/>
                      </div>
                    </button>
                  </div>

                </div>

                <CustomTable filterRow idTable="tableStatistics" getItems={(offSet,pageSize,params)=> getStretcherBearerInformation({offSet:offSet,pageSize:pageSize,params:params})} hideFiltersButton showGridlines params={{
                  sector:selectedSector?selectedSector.sector:null,
                  patient: selectedPatient?selectedPatient.medereentity:null,
                  fromDate:fromDate,
                  toDate:toDate, 
                  _userstretbearer:selectedStretcherBearer?selectedStretcherBearer._userstretbearer:null,
                  fromHour: fromHour!= null? Number(fromHour): null,
                  fromMinute: fromMinute!= null? Number(fromMinute): null,
                  toHour: toHour!= null? Number(toHour): null,
                  toMinute: toMinute!= null? Number(toMinute): null}} className="crudTable" ref={queryRef} itemSize={40}>

                    <Column
                      field="openWindow"
                      body={(record:PatientTransferDTO) => {
                        const buttonStyle = {
                          height: '23px',
                          color: '#14C7BC',
                          backgroundColor: 'transparent',
                          border: 'none',
                        };
                        return (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Button
                            onClick={() => handleClickDetails(record)}
                            icon='pi pi-ellipsis-v'
                            iconPos= "left"
                            style={buttonStyle}
                          />
                        </div>
                      );}} className="columnSquare"
                    />
                    <Column field="requestedtime" header={intl.formatMessage({id:'RequestedTime'})} className="columnDt columnGen" body={(x)=>{
                        return format(parseISO(x.requestedtime),'dd/MM/yyyy HH:mm')
                    }}/>
                    <Column field="stretbearerfullname" header={intl.formatMessage({ id: 'StretcherBearer' })} className="column columnGen"/>               
                    <Column field="fullname" header={intl.formatMessage({ id: 'Patient' })} className="column columnGen" />
                    <Column field="prioritydescription" header={intl.formatMessage({id:'Priority'})} className="columnDly columnGen"/>
                    <Column field="namecurrentsector" header={intl.formatMessage({id:'Origin'})} className="column columnGen"/>
                    <Column field="namenewsector" header={intl.formatMessage({id:'Destiny'})} className="column columnGen"/>
                    <Column field="totaltimetransfer" header={intl.formatMessage({ id: 'Duration' })} className="columnDly columnGen" />            
                    <Column field="statusdescription" header={intl.formatMessage({ id: 'Status' })} className="columnSt columnGen" />
                    <Column
                      field="openWindow"
                      body={(record:PatientTransferDTO) => {
                        return (
                        <div>
                          {((record.currentstatus == TransferStatus.FINISHED && record.comments && record.comments != "") || (record.currentstatus == TransferStatus.CANCELLED && record.cancellationreasondescription)) && (<Button icon='pi pi-comment' onClick={() => handleClickComments(record)} style={{ color: '#B67345', backgroundColor: 'transparent', border: 'none', fontSize:'15px' }}></Button>)}
                        </div>
                      );}} className="columnSquare columnGen"
                    />
                </CustomTable>
              </TabPanel>
              <TabPanel header={"Análisis Día/Hora"}>
                <HeatMapPatientTransferView  />
              </TabPanel>
            </TabView>

            {openCommentWindow && (
              <div className="flex flex-column gap-2">
                <div className="modal-overlay">
                  <div className="modal-container">
                    <div className="modal-header">
                      <h2 style={{fontWeight:500, fontSize: recordStatus === TransferStatus.FINISHED? '20px':'18px'}}>{recordStatus === TransferStatus.FINISHED ? intl.formatMessage({ id: 'Comments' }) : intl.formatMessage({ id: 'CancellationReason' })}</h2>
                      <button style={{ fontSize: '28px', paddingLeft:'8px', paddingBottom:'8px' }} className="close-button" onClick={ () => setOpenCommentWindow(false)}>&times;</button>
                    </div>
                    <div className="modal-content">
                      {recordStatus == TransferStatus.FINISHED && (
                        <div className="p-m-4">
                            {comments && comments != "" && (<textarea className="comment-box" defaultValue={comments}/>)}
                        </div>
                      )}

                      {recordStatus == TransferStatus.CANCELLED && (
                        <div className="p-m-4">
                          {cancellationReasonDescription && cancellationReasonDescription != "" && (<h2 style={{ marginLeft: '3px', marginTop: '5px', fontSize: '17px' }}>{cancellationReasonDescription}</h2>)}
                          {cancellationReasonDetail && cancellationReasonDetail != "" && (<h2 style={{ marginLeft: '3px', marginTop: '5px', fontSize: '17px' }}>{intl.formatMessage({ id: 'Description' })}:</h2>)}
                          {cancellationReasonDetail && cancellationReasonDetail != "" && (<textarea className="comment-box" defaultValue={cancellationReasonDetail}/>)}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <Modal visible={openDetailsWindow} setVisible={setOpenDetailsWindow} className="custom-modal" header={intl.formatMessage({ id: 'TransferDetails' })}>
              <div className="flex flex-column gap-2">

                {selectedTransferRequest && (<TransferRequestCard
                  key={selectedTransferRequest.patienttransfer}
                  record={selectedTransferRequest}
                  userId={userId}
                  details
                  showTimes
                />)} 

              </div>
            </Modal>

            <Modal visible={openPendingProgressWindow} setVisible={setOpenPendingProgressWindow} className="custom-modal" header={recordStatus === TransferStatus.INPROGRESS ? <span> {intl.formatMessage({ id: 'TransferDetails' })} <span style={{ color: 'green' }}>{intl.formatMessage({ id: 'inProgress' })}</span></span> : intl.formatMessage({ id: 'TransferDetails' }) }>
              <div className="flex flex-column gap-2">

                {selectedTransferRequest && (<TransferRequestCard
                  key={selectedTransferRequest.patienttransfer}
                  record={selectedTransferRequest}
                  userId={userId}
                  details
                />)} 

              </div>
            </Modal>

            <Modal visible={isNotificationDisabled} setVisible={setIsNotificationDisabled} header={intl.formatMessage({ id: 'YouDontHaveNotificationsEnabled' })} onClickRightBtn={() => setIsNotificationDisabled(false)}>
                <div style={{ margin: '10px 0', fontSize: '16px', lineHeight: '1.5' }}>
                {intl.formatMessage({ id: 'WeAskYouTo' })}:
                    <div style={{ margin: '20px', padding: '15px', border: '2px solid black' }}>
                        {isAndroid && (<p>{intl.formatMessage({ id: 'OnYourAndroidDevice' })}:</p>)}
                        {isIPhone && (<p>{intl.formatMessage({ id: 'OnYourIPhoneDevice' })}:</p>)}
                        {(isAndroid || isIPhone) && (<ol style={{ marginLeft: '20px' }}>
                            <li>1. {intl.formatMessage({ id: 'GoToSettingsOnYourDevice' })}</li>
                            <li>2. {intl.formatMessage({ id: 'GoToNotifications' })}</li>
                            <li>3. {intl.formatMessage({ id: 'EnableThemForYourNavigator' })}</li>
                        </ol>)}
                        <p>{intl.formatMessage({ id: 'IfProblemPersistTry' })}:</p>
                        <ol style={{ marginLeft: '20px' }}>
                            <li>1. {intl.formatMessage({ id: 'GoToSettingsOnYourNavigator' })}</li>
                            <li>2. {intl.formatMessage({ id: 'GoToPrivacyAndSecurity->DeleteNavigationData' })}</li>
                            <li>3. {intl.formatMessage({ id: 'DeleteYourCookiesOrCache' })}</li>
                            <li>4. {intl.formatMessage({ id: 'TryVerifyingIfSomethingIsBlockingNotificationsInNavigatorOrDevice' })}</li>
                            <li>5. {intl.formatMessage({ id: 'ToReceiveNotificationsWeRecommendDisablingIncognitoModeTryOpeningARegularTabToEnableNotificationPermissions' })}</li>
                        </ol>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                  <Button className='buttonMain' style={{ marginRight: '10px' }} onClick={() => setIsNotificationDisabled(false)}>
                    {intl.formatMessage({ id: 'Accept' })}
                  </Button>
                </div>
            </Modal>

            {openReportDataWindow && (
              <div className="modal-overlay">
                <div className="modal-container">
                  <div className="modal-header">
                    <h2 style={{fontWeight:400, fontSize:'18px', color: 'black'}}><strong>{intl.formatMessage({ id: 'TransferReport' })}</strong>{' '+intl.formatMessage({ id: 'since' })+' '+formattedFromDate+' '+intl.formatMessage({ id: 'To' })+' '+formattedToDate}</h2>
                    <button style={{ fontSize: '28px' }} className="close-button" onClick={ () => setOpenReportDataWindow(false)}>&times;</button>
                  </div>
                  
                  <div className="cards-container">
                    <div style={{display:'flex', flexDirection: isMobile ? "column" : "row"}}>
                      <div style={{minWidth: isMobile ? "" : "460px"}}>
                        <LinedCard icon='bi:arrow-left-right' iconBackgroundColor="#f9dad6" header={intl.formatMessage({ id: 'TRANSFERS' })}>
                          <h3 style={{ fontSize: '16px', color: 'black', fontWeight: 600 }}>{stretcherBearerData && stretcherBearerData.length > 0 && (stretcherBearerData.reduce((total, item) => total + item.transferquantitypersb, 0))} {intl.formatMessage({ id: 'Transfers' })}</h3>
                          
                          {stretcherBearerData && stretcherBearerData.length > 0 && (
                            stretcherBearerData.map((item, index) => (
                              <div key={index}>
                                <h3 style={{ marginTop: '1px', fontSize: '14px', color: 'black' }}>{item.transferquantitypersb} {item.fullname}</h3>
                              </div>
                            ))
                          )}
                          
                          {statusData && statusData.length > 0 && (
                            statusData.map((item, index) => (
                              <div key={index}>
                                <h3 style={{fontSize: '16px', color: 'black', fontWeight: 600, display:'flex' }}><span style={{marginRight:'5px', color: item.description==intl.formatMessage({ id: 'Finished' })?'green':''}}>{item.percentageofstatus}</span> {item.description}{item.description=="Finalizado" || item.description=="Cancelado"? 's':''}</h3>
                              </div>
                            ))
                          )}
                        </LinedCard>

                        <LinedCard icon='bi:x-circle-fill' iconBackgroundColor="#f9dad6" header={intl.formatMessage({ id: 'CANCELLATIONREASONS' })}>
                          {cancellationReasonData && cancellationReasonData.length > 0 && (
                            cancellationReasonData.map((item, index) => (
                              <div key={index}>
                                <h3 style={{ marginTop: '1px', fontSize: '14px', color: 'black' }}>{item.percentageofcancellationreasons} {item.description}</h3>
                              </div>
                            ))
                          )}
                        </LinedCard>

                        <LinedCard icon='bi:person-wheelchair' iconBackgroundColor="#f9dad6" header={intl.formatMessage({ id: 'CONVEYANCES' })}>
                          {conveyanceData && conveyanceData.length > 0 && (
                            conveyanceData.map((item, index) => (
                              <div key={index}>
                                <h3 style={{ fontSize: '16px', color: 'black', fontWeight: 600 }}>{item.percentageofconveyances} {item.conveyance}</h3>
                              </div>
                            ))
                          )}
                        </LinedCard>
                      </div>

                      <div>
                        <LinedCard icon='bi:clock' iconBackgroundColor="#f9dad6" header={intl.formatMessage({ id: 'DURATION' })}>
                          
                          {/*Tiempo total del traslado (son promedios)*/}
                          <h3 style={{ fontSize: '16px', color: 'black', fontWeight: 600 }}>{averages.avgRequestedTo+' '+'hs'} {intl.formatMessage({ id: 'averageTransferTime' })}</h3>
                          
                          {stretcherBearerData && stretcherBearerData.length > 0 && (
                            stretcherBearerData.map((item, index) => (
                              <div key={index}>
                                <h3 style={{ marginTop: '1px', fontSize: '14px', color: 'black' }}>{item.avgrequestedto} {item.fullname}</h3>
                              </div>
                            ))
                          )}

                          {/*Tiempo desde que esta con paciente a fin de traslado (son promedios)*/}
                          <h3 style={{ fontSize: '16px', color: 'black', fontWeight: 600 }}>{averages.avgFromPatientTo+' '+'hs'} {intl.formatMessage({ id: 'averageTransferingPatientTime' })}</h3>
                          
                          {stretcherBearerData && stretcherBearerData.length > 0 && (
                            stretcherBearerData.map((item, index) => (
                              <div key={index}>
                                <h3 style={{ marginTop: '1px', fontSize: '14px', color: 'black' }}>{item.avgfrompatientto? item.avgfrompatientto:'00:00:00'} {item.fullname}</h3>
                              </div>
                            ))
                          )}

                          {/*Demora de inicio (Demora desde que acepto hasta que está con el paciente) (son promedios)*/}
                          <h3 style={{ fontSize: '16px', color: 'black', fontWeight: 600 }}>{averages.avgFromDateFromPatientDate+' '+'hs'} {intl.formatMessage({ id: 'averageInitDelay' })}</h3>
                          
                          {stretcherBearerData && stretcherBearerData.length > 0 && (
                            stretcherBearerData.map((item, index) => (
                              <div key={index}>
                                <h3 style={{ marginTop: '1px', fontSize: '14px', color: 'black' }}>{item.avgfromdatefrompatientdate? item.avgfromdatefrompatientdate:'00:00:00'} {item.fullname}</h3>
                              </div>
                            ))
                          )}
                          
                          {/*Demora de tomado (son promedios)*/}
                          <h3 style={{ fontSize: '16px', color: 'black', fontWeight: 600 }}>{averages.avgRequestFrom+' '+'hs'} {intl.formatMessage({ id: 'averageAcceptanceDelay' })}</h3>
          
                          {stretcherBearerData && stretcherBearerData.length > 0 && (
                            stretcherBearerData.map((item, index) => (
                              <div key={index}>
                                <h3 style={{ marginTop: '1px', fontSize: '14px', color: 'black' }}>{item.avgrequestfrom} {item.fullname}</h3>
                              </div>
                            ))
                          )}
                        </LinedCard>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {openLoguedStretcherBearersWindow && (
              <div className="modal-overlay">
              <div className="modal-container">
                <div className="modal-header">
                  <h2 style={{fontWeight:400, fontSize:'18px', color: 'black'}}>{intl.formatMessage({ id: 'LoguedStretcherBearers' })}</h2>
                  <button style={{ fontSize: '28px' }} className="close-button" onClick={ () => setOpenLoguedStretcherBearersWindow(false)}>&times;</button>
                </div>
                
                <div className="cards-container">
                  <div style={{display:'flex', flexDirection: isMobile ? "column" : "row"}}>
                    <div style={{minWidth: isMobile ? "" : "460px"}}>
                      <LinedCard icon='bi:person-fill' iconBackgroundColor="#f9dad6" header={intl.formatMessage({ id: 'StretcherBearers' })}>
                        {loguedStretcherBearersData && loguedStretcherBearersData.length > 0 && (
                          loguedStretcherBearersData.map((item, index) => (
                            <div key={index}>
                              <h3 style={{ fontSize: '16px', color: 'black', fontWeight: 600 }}>{item.stretbearerfullname}</h3>
                            </div>
                          ))
                        )}
                      </LinedCard>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

            <Toast ref={toast} position="bottom-right" />

        </div>
    )

}
